import { lazy } from "react";
import LazyRoute from "../components/Common/LazyRoute";
import ROUTES from "./ROUTES";

const OrderCreate = lazy(() => import("../components/Order/ParentOrderCreate.jsx"));
const OrderView = lazy(() => import("../components/Order/ParentOrderView.jsx"));
const OrderSummary = lazy(() => import("../components/Order/ParentOrderSummary.jsx"));
const AutomationOrderCreate = lazy(() => import("../components/Auto-Order/ParentOrderCreate.jsx"));
const DomainTransfer = lazy(() => import("../components/Auto-Order/Addon/DomainTransfer/ParentDomainTransfer.jsx"));
const BulkOrderCreate = lazy(() => import("@/components/Order/User/Create/BulkOrder/Upload"));

export default [
  { path: ROUTES.ORDERS.VIEW, element: <LazyRoute><OrderView /></LazyRoute> },
  { path: ROUTES.ORDERS.CREATE, element: <LazyRoute><OrderCreate /></LazyRoute> },
  { path: ROUTES.ORDERS.SUMMARY, element: <LazyRoute><OrderSummary /></LazyRoute> },
  { path: ROUTES.ORDERS.AUTO_CREATE, element: <LazyRoute><AutomationOrderCreate /></LazyRoute> },
  { path: ROUTES.ORDERS.DOMAIN_TRANSFER, element: <LazyRoute><DomainTransfer /></LazyRoute> },
  { path: ROUTES.ORDERS.BULK_ORDER_CREATE, element: <LazyRoute><BulkOrderCreate /></LazyRoute> },
];
